import { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";

import PreloadAppData from "../../components/Utils/PreloadAppData";
import { CalendarStoreProvider } from "../../calendar/master";
import { isSubstituteInstructorType } from "../../constants/instructors";
import { canOpenStudentProfile } from "../../auth/studentProfileAccess";
import { useResolvedInstructor } from "../../hooks/useResolvedInstructor";
import { canUseCalendarV2, newCalendarPathFor, readCalendarChoice } from "../../calendarV2/calendarV2Access";

const CalendarExtremeOptimized = lazy(() =>
   import("../../components/APanel/CalendarExtreme/ACalendarOptimized"),
);

function IPCalendar() {
   const { instructor, resolved, user } = useResolvedInstructor();

   // cine a ales calendarul nou ajunge direct acolo (din meniu „Orarul meu”)
   if (user && canUseCalendarV2(user) && readCalendarChoice(user) === "v2") {
      return <Navigate to={newCalendarPathFor(user)} replace />;
   }

   if (user?.role === "INSTRUCTOR" && !resolved) {
      return (
         <main className="main" style={{ padding: 0 }}>
            <div className="dayview__loading" role="status" aria-live="polite">
               <div className="dayview__spinner" />
               <span>Se incarca profilul instructorului...</span>
            </div>
         </main>
      );
   }

   if (user?.role === "INSTRUCTOR" && !instructor?.id) {
      return (
         <main className="main" style={{ padding: 0 }}>
            <div className="dayview__loading" role="status" aria-live="polite">
               <span>Profilul de instructor nu a fost gasit.</span>
            </div>
         </main>
      );
   }

   return (
      <main className="main" style={{ padding: 0 }}>
         <PreloadAppData />
         <Suspense
            fallback={
               <div className="dayview__loading" role="status" aria-live="polite">
                  <div className="dayview__spinner" />
                  <span>Se incarca Orarul Meu...</span>
               </div>
            }
         >
            <CalendarStoreProvider>
               <CalendarExtremeOptimized
                  canEditOrder={false}
                  canBlockSlot={false}
                  canWriteNotes={false}
                  canCreateReservation={true}
                  showTopWaitCancelZone={false}
                  enableLateralColumn={false}
                  studentProfileMode="instructor-self"
                  canOpenStudentProfile={canOpenStudentProfile(user, instructor)}
                  scopedInstructorId={instructor?.id}
                  substituteScheduleMode={isSubstituteInstructorType(
                     instructor?.instructorType,
                  )}
               />
            </CalendarStoreProvider>
         </Suspense>
      </main>
   );
}

export default IPCalendar;
